/** Report keys matching BusinessReports `ReportType` and backend investor permissions. */
export const INVESTOR_BUSINESS_REPORT_OPTIONS = [
  { key: 'summary', label: 'Summary Report' },
  { key: 'revenue', label: 'Revenue Report' },
  { key: 'revenue_breakdown', label: 'Revenue Breakdown' },
  { key: 'pharma_revenue', label: 'Pharma revenue (detailed)' },
  { key: 'pharma_consumption', label: 'Medicine consumption (OPD/IPD/OT)' },
  { key: 'lab_billing', label: 'Lab billing (detailed)' },
  { key: 'gst_filing', label: 'GST filing report' },
  { key: 'additional_services', label: 'Additional Services Report' },
  { key: 'appointments', label: 'Appointments Report' },
  { key: 'lab', label: 'Lab Operations Report' },
  { key: 'expenses', label: 'Expense Report' },
  { key: 'monthly_expenses', label: 'Monthly expenses (service month)' },
  { key: 'monthly_performance', label: 'Monthly Business Performance' },
  { key: 'pnl', label: 'P&L Statement (MTD / YTD / MoM)' },
  { key: 'cash_flow', label: 'Cash Flow Statement (MTD / YTD / MoM)' },
  { key: 'patients', label: 'Patient Analytics' },
  { key: 'patient_master', label: 'Patient Master' },
  { key: 'patient_billing', label: 'Patient-wise Billing Detail' },
  { key: 'bill_wise', label: 'Bill-wise Report (All modules)' },
  { key: 'ipd_profitability', label: 'IPD Profitability (Discharged)' },
  { key: 'plastic_surgery_revenue', label: 'Plastic Surgery Revenue' },
  { key: 'plastic_surgery_profitability', label: 'Plastic Surgery Profitability (Patient-wise)' },
  { key: 'opd_payment_lines', label: 'OPD Payments (line-wise CSV)' },
  { key: 'daycare_payment_lines', label: 'Day Care Payments (line-wise CSV)' },
  { key: 'sales_attribution', label: 'Sales Report' },
] as const;

export type InvestorBusinessReportKey = (typeof INVESTOR_BUSINESS_REPORT_OPTIONS)[number]['key'];

export const INVESTOR_BUSINESS_REPORT_KEYS = INVESTOR_BUSINESS_REPORT_OPTIONS.map(
  (o) => o.key
) as InvestorBusinessReportKey[];
